/*
 Highcharts JS v8.2.2 (2020-10-22)

 (c) 2009-2019 Sebastian Bochan, Rafal Sebestjanski

 License: www.highcharts.com/license
*/
(function (c) {
  "object" === typeof module && module.exports ? (c["default"] = c, module.exports = c) : "function" === typeof define && define.amd ? define("highcharts/modules/dumbbell", ["highcharts"], function (n) {
    c(n);
    c.Highcharts = n;
    return c;
  }) : c("undefined" !== typeof Highcharts ? Highcharts : void 0);
})(function (c) {
  function n(c, p, t, h) {
    c.hasOwnProperty(p) || (c[p] = h.apply(null, t));
  }

  c = c ? c._modules : {};
  n(c, "Series/AreaRangeSeries.js", [c["Core/Series/Series.js"], c["Core/Globals.js"], c["Core/Series/Point.js"], c["Core/Utilities.js"]], function (c, p, t, h) {
    var w = h.defined,
        m = h.extend,
        n = h.isArray,
        d = h.isNumber,
        v = h.pick,
        u = c.seriesTypes.area.prototype,
        b = c.seriesTypes.column.prototype,
        q = t.prototype,
        r = p.Series.prototype;
    c.seriesType("arearange", "area", {
      lineWidth: 1,
      threshold: null,
      tooltip: {
        pointFormat: "<span style=\"color:{series.color}\">\u25CF</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>"
      },
      trackByArea: !0,
      dataLabels: {
        align: void 0,
        verticalAlign: void 0,
        xLow: 0,
        xHigh: 0,
        yLow: 0,
        yHigh: 0
      }
    }, {
      pointArrayMap: ["low", "high"],
      pointValKey: "low",
      deferTranslatePolar: !0,
      toYData: function toYData(f) {
        return [f.low, f.high];
      },
      highToXY: function highToXY(f) {
        var b = this.chart,
            a = this.xAxis.postTranslate(f.rectPlotX, this.yAxis.len - f.plotHigh);
        f.plotHighX = a.x - b.plotLeft;
        f.plotHigh = a.y - b.plotTop;
        f.plotLowX = f.plotX;
      },
      translate: function translate() {
        var f = this,
            b = f.yAxis,
            a = !!f.modifyValue;
        u.translate.apply(f);
        f.points.forEach(function (e) {
          var c = e.high,
              g = e.plotY;
          e.isNull ? e.plotY = null : (e.plotLow = g, e.plotHigh = b.translate(a ? f.modifyValue(c, e) : c, 0, 1, 0, 1), a && (e.yBottom = e.plotHigh));
        });
        this.chart.polar && this.points.forEach(function (a) {
          f.highToXY(a);
          a.tooltipPos = [(a.plotHighX + a.plotLowX) / 2, (a.plotHigh + a.plotLow) / 2];
        });
      },
      getGraphPath: function getGraphPath(f) {
        var b = [],
            a = [],
            c,
            y = u.getGraphPath;
        var g = this.options;
        var r = this.chart.polar,
            l = r && !1 !== g.connectEnds,
            k = g.connectNulls,
            q = g.step;
        f = f || this.points;

        for (c = f.length; c--;) {
          var d = f[c];
          var h = r ? {
            plotX: d.rectPlotX,
            plotY: d.yBottom,
            doCurve: !1
          } : {
            plotX: d.plotX,
            plotY: d.plotY,
            doCurve: !1
          };
          d.isNull || l || k || f[c + 1] && !f[c + 1].isNull || a.push(h);
          var m = {
            polarPlotY: d.polarPlotY,
            rectPlotX: d.rectPlotX,
            yBottom: d.yBottom,
            plotX: v(d.plotHighX, d.plotX),
            plotY: d.plotHigh,
            isNull: d.isNull
          };
          a.push(m);
          b.push(m);
          d.isNull || l || k || f[c - 1] && !f[c - 1].isNull || a.push(h);
        }

        f = y.call(this, f);
        q && (!0 === q && (q = "left"), g.step = {
          left: "right",
          center: "center",
          right: "left"
        }[q]);
        b = y.call(this, b);
        a = y.call(this, a);
        g.step = q;
        g = [].concat(f, b);
        !this.chart.polar && a[0] && "M" === a[0][0] && (a[0] = ["L", a[0][1], a[0][2]]);
        this.graphPath = g;
        this.areaPath = f.concat(a);
        g.isArea = !0;
        g.xMap = f.xMap;
        this.areaPath.xMap = f.xMap;
        return g;
      },
      drawDataLabels: function drawDataLabels() {
        var b = this.points,
            e = b.length,
            a,
            c = [],
            d = this.options.dataLabels,
            g,
            q = this.chart.inverted;

        if (n(d)) {
          var l = d[0] || {
            enabled: !1
          };
          var k = d[1] || {
            enabled: !1
          };
        } else l = m({}, d), l.x = d.xHigh, l.y = d.yHigh, k = m({}, d), k.x = d.xLow, k.y = d.yLow;

        if (l.enabled || this._hasPointLabels) {
          for (a = e; a--;) {
            if (g = b[a]) {
              var h = l.inside ? g.plotHigh < g.plotLow : g.plotHigh > g.plotLow;
              g.y = g.high;
              g._plotY = g.plotY;
              g.plotY = g.plotHigh;
              c[a] = g.dataLabel;
              g.dataLabel = g.dataLabelUpper;
              g.below = h;
              q ? l.align || (l.align = h ? "right" : "left") : l.verticalAlign || (l.verticalAlign = h ? "top" : "bottom");
            }
          }

          this.options.dataLabels = l;
          r.drawDataLabels && r.drawDataLabels.apply(this, arguments);

          for (a = e; a--;) {
            if (g = b[a]) g.dataLabelUpper = g.dataLabel, g.dataLabel = c[a], delete g.dataLabels, g.y = g.low, g.plotY = g._plotY;
          }
        }

        if (k.enabled || this._hasPointLabels) {
          for (a = e; a--;) {
            if (g = b[a]) h = k.inside ? g.plotHigh < g.plotLow : g.plotHigh > g.plotLow, g.below = !h, q ? k.align || (k.align = h ? "left" : "right") : k.verticalAlign || (k.verticalAlign = h ? "bottom" : "top");
          }

          this.options.dataLabels = k;
          r.drawDataLabels && r.drawDataLabels.apply(this, arguments);
        }

        if (l.enabled) for (a = e; a--;) {
          if (g = b[a]) g.dataLabels = [g.dataLabelUpper, g.dataLabel].filter(function (a) {
            return !!a;
          });
        }
        this.options.dataLabels = d;
      },
      alignDataLabel: function alignDataLabel() {
        b.alignDataLabel.apply(this, arguments);
      },
      drawPoints: function drawPoints() {
        var b = this.points.length,
            e;
        r.drawPoints.apply(this, arguments);

        for (e = 0; e < b;) {
          var a = this.points[e];
          a.origProps = {
            plotY: a.plotY,
            plotX: a.plotX,
            isInside: a.isInside,
            negative: a.negative,
            zone: a.zone,
            y: a.y
          };
          a.lowerGraphic = a.graphic;
          a.graphic = a.upperGraphic;
          a.plotY = a.plotHigh;
          w(a.plotHighX) && (a.plotX = a.plotHighX);
          a.y = a.high;
          a.negative = a.high < (this.options.threshold || 0);
          a.zone = this.zones.length && a.getZone();
          this.chart.polar || (a.isInside = a.isTopInside = "undefined" !== typeof a.plotY && 0 <= a.plotY && a.plotY <= this.yAxis.len && 0 <= a.plotX && a.plotX <= this.xAxis.len);
          e++;
        }

        r.drawPoints.apply(this, arguments);

        for (e = 0; e < b;) {
          a = this.points[e], a.upperGraphic = a.graphic, a.graphic = a.lowerGraphic, m(a, a.origProps), delete a.origProps, e++;
        }
      },
      setStackedPoints: p.noop
    }, {
      setState: function setState() {
        var b = this.state,
            e = this.series,
            a = e.chart.polar;
        w(this.plotHigh) || (this.plotHigh = e.yAxis.toPixels(this.high, !0));
        w(this.plotLow) || (this.plotLow = this.plotY = e.yAxis.toPixels(this.low, !0));
        e.stateMarkerGraphic && (e.lowerStateMarkerGraphic = e.stateMarkerGraphic, e.stateMarkerGraphic = e.upperStateMarkerGraphic);
        this.graphic = this.upperGraphic;
        this.plotY = this.plotHigh;
        a && (this.plotX = this.plotHighX);
        q.setState.apply(this, arguments);
        this.state = b;
        this.plotY = this.plotLow;
        this.graphic = this.lowerGraphic;
        a && (this.plotX = this.plotLowX);
        e.stateMarkerGraphic && (e.upperStateMarkerGraphic = e.stateMarkerGraphic, e.stateMarkerGraphic = e.lowerStateMarkerGraphic, e.lowerStateMarkerGraphic = void 0);
        q.setState.apply(this, arguments);
      },
      haloPath: function haloPath() {
        var b = this.series.chart.polar,
            e = [];
        this.plotY = this.plotLow;
        b && (this.plotX = this.plotLowX);
        this.isInside && (e = q.haloPath.apply(this, arguments));
        this.plotY = this.plotHigh;
        b && (this.plotX = this.plotHighX);
        this.isTopInside && (e = e.concat(q.haloPath.apply(this, arguments)));
        return e;
      },
      destroyElements: function destroyElements() {
        ["lowerGraphic", "upperGraphic"].forEach(function (b) {
          this[b] && (this[b] = this[b].destroy());
        }, this);
        this.graphic = null;
        return q.destroyElements.apply(this, arguments);
      },
      isValid: function isValid() {
        return d(this.low) && d(this.high);
      }
    });
    "";
  });
  n(c, "Series/ColumnRangeSeries.js", [c["Core/Series/Series.js"], c["Core/Globals.js"], c["Core/Options.js"], c["Core/Utilities.js"]], function (c, p, t, h) {
    p = p.noop;
    t = t.defaultOptions;
    var n = h.clamp,
        m = h.merge,
        x = h.pick,
        d = c.seriesTypes.column.prototype;
    c.seriesType("columnrange", "arearange", m(t.plotOptions.column, t.plotOptions.arearange, {
      pointRange: null,
      marker: null,
      states: {
        hover: {
          halo: !1
        }
      }
    }), {
      translate: function translate() {
        var c = this,
            h = c.yAxis,
            b = c.xAxis,
            q = b.startAngleRad,
            r,
            f = c.chart,
            e = c.xAxis.isRadial,
            a = Math.max(f.chartWidth, f.chartHeight) + 999,
            m;
        d.translate.apply(c);
        c.points.forEach(function (d) {
          var g = d.shapeArgs,
              p = c.options.minPointLength;
          d.plotHigh = m = n(h.translate(d.high, 0, 1, 0, 1), -a, a);
          d.plotLow = n(d.plotY, -a, a);
          var l = m;
          var k = x(d.rectPlotY, d.plotY) - m;
          Math.abs(k) < p ? (p -= k, k += p, l -= p / 2) : 0 > k && (k *= -1, l -= k);
          e ? (r = d.barX + q, d.shapeType = "arc", d.shapeArgs = c.polarArc(l + k, l, r, r + d.pointWidth)) : (g.height = k, g.y = l, d.tooltipPos = f.inverted ? [h.len + h.pos - f.plotLeft - l - k / 2, b.len + b.pos - f.plotTop - g.x - g.width / 2, k] : [b.left - f.plotLeft + g.x + g.width / 2, h.pos - f.plotTop + l + k / 2, k]);
        });
      },
      directTouch: !0,
      trackerGroups: ["group", "dataLabelsGroup"],
      drawGraph: p,
      getSymbol: p,
      crispCol: function crispCol() {
        return d.crispCol.apply(this, arguments);
      },
      drawPoints: function drawPoints() {
        return d.drawPoints.apply(this, arguments);
      },
      drawTracker: function drawTracker() {
        return d.drawTracker.apply(this, arguments);
      },
      getColumnMetrics: function getColumnMetrics() {
        return d.getColumnMetrics.apply(this, arguments);
      },
      pointAttribs: function pointAttribs() {
        return d.pointAttribs.apply(this, arguments);
      },
      animate: function animate() {
        return d.animate.apply(this, arguments);
      },
      polarArc: function polarArc() {
        return d.polarArc.apply(this, arguments);
      },
      translate3dPoints: function translate3dPoints() {
        return d.translate3dPoints.apply(this, arguments);
      },
      translate3dShapes: function translate3dShapes() {
        return d.translate3dShapes.apply(this, arguments);
      }
    }, {
      setState: d.pointClass.prototype.setState
    });
    "";
  });
  n(c, "Series/DumbbellSeries.js", [c["Core/Series/Series.js"], c["Core/Renderer/SVG/SVGRenderer.js"], c["Core/Globals.js"], c["Core/Utilities.js"]], function (c, p, n, h) {
    var t = h.extend,
        m = h.pick,
        x = n.Series.prototype;
    h = c.seriesTypes;
    var d = h.arearange.prototype,
        v = h.column.prototype,
        u = d.pointClass.prototype;
    c.seriesType("dumbbell", "arearange", {
      trackByArea: !1,
      fillColor: "none",
      lineWidth: 0,
      pointRange: 1,
      connectorWidth: 1,
      stickyTracking: !1,
      groupPadding: .2,
      crisp: !1,
      pointPadding: .1,
      lowColor: "#333333",
      states: {
        hover: {
          lineWidthPlus: 0,
          connectorWidthPlus: 1,
          halo: !1
        }
      }
    }, {
      trackerGroups: ["group", "markerGroup", "dataLabelsGroup"],
      drawTracker: n.TrackerMixin.drawTrackerPoint,
      drawGraph: n.noop,
      crispCol: v.crispCol,
      getConnectorAttribs: function getConnectorAttribs(b) {
        var c = this.chart,
            d = b.options,
            f = this.options,
            e = this.xAxis,
            a = this.yAxis,
            h = m(d.connectorWidth, f.connectorWidth),
            n = m(d.connectorColor, f.connectorColor, d.color, b.zone ? b.zone.color : void 0, b.color),
            g = m(f.states && f.states.hover && f.states.hover.connectorWidthPlus, 1),
            u = m(d.dashStyle, f.dashStyle),
            l = m(b.plotLow, b.plotY),
            k = a.toPixels(f.threshold || 0, !0);
        k = m(b.plotHigh, c.inverted ? a.len - k : k);
        b.state && (h += g);
        0 > l ? l = 0 : l >= a.len && (l = a.len);
        0 > k ? k = 0 : k >= a.len && (k = a.len);
        if (0 > b.plotX || b.plotX > e.len) h = 0;
        b.upperGraphic && (e = {
          y: b.y,
          zone: b.zone
        }, b.y = b.high, b.zone = b.zone ? b.getZone() : void 0, n = m(d.connectorColor, f.connectorColor, d.color, b.zone ? b.zone.color : void 0, b.color), t(b, e));
        b = {
          d: p.prototype.crispLine([["M", b.plotX, l], ["L", b.plotX, k]], h, "ceil")
        };
        c.styledMode || (b.stroke = n, b["stroke-width"] = h, u && (b.dashstyle = u));
        return b;
      },
      drawConnector: function drawConnector(b) {
        var c = m(this.options.animationLimit, 250);
        c = b.connector && this.chart.pointCount < c ? "animate" : "attr";
        b.connector || (b.connector = this.chart.renderer.path().addClass("highcharts-lollipop-stem").attr({
          zIndex: -1
        }).add(this.markerGroup));
        b.connector[c](this.getConnectorAttribs(b));
      },
      getColumnMetrics: function getColumnMetrics() {
        var b = v.getColumnMetrics.apply(this, arguments);
        b.offset += b.width / 2;
        return b;
      },
      translatePoint: d.translate,
      setShapeArgs: h.columnrange.prototype.translate,
      translate: function translate() {
        this.setShapeArgs.apply(this);
        this.translatePoint.apply(this, arguments);
        this.points.forEach(function (b) {
          var c = b.shapeArgs,
              d = b.pointWidth;
          b.plotX = c.x;
          c.x = b.plotX - d / 2;
          b.tooltipPos = null;
        });
        this.columnMetrics.offset -= this.columnMetrics.width / 2;
      },
      seriesDrawPoints: d.drawPoints,
      drawPoints: function drawPoints() {
        var b = this.chart,
            c = this.points.length,
            d = this.lowColor = this.options.lowColor,
            f = 0;

        for (this.seriesDrawPoints.apply(this, arguments); f < c;) {
          var e = this.points[f];
          this.drawConnector(e);
          e.upperGraphic && (e.upperGraphic.element.point = e, e.upperGraphic.addClass("highcharts-lollipop-high"));
          e.connector.element.point = e;

          if (e.lowerGraphic) {
            var a = e.zone && e.zone.color;
            a = m(e.options.lowColor, d, e.options.color, a, e.color, this.color);
            b.styledMode || e.lowerGraphic.attr({
              fill: a
            });
            e.lowerGraphic.addClass("highcharts-lollipop-low");
          }

          f++;
        }
      },
      markerAttribs: function markerAttribs() {
        var b = d.markerAttribs.apply(this, arguments);
        b.x = Math.floor(b.x);
        b.y = Math.floor(b.y);
        return b;
      },
      pointAttribs: function pointAttribs(b, c) {
        var d = x.pointAttribs.apply(this, arguments);
        "hover" === c && delete d.fill;
        return d;
      }
    }, {
      destroyElements: u.destroyElements,
      isValid: u.isValid,
      pointSetState: u.setState,
      setState: function setState() {
        var b = this.series,
            c = b.chart,
            d = b.options.marker,
            f = this.options,
            e = m(f.lowColor, b.options.lowColor, f.color, this.zone && this.zone.color, this.color, b.color),
            a = "attr";
        this.pointSetState.apply(this, arguments);
        this.state || (a = "animate", this.lowerGraphic && !c.styledMode && (this.lowerGraphic.attr({
          fill: e
        }), this.upperGraphic && (c = {
          y: this.y,
          zone: this.zone
        }, this.y = this.high, this.zone = this.zone ? this.getZone() : void 0, d = m(this.marker ? this.marker.fillColor : void 0, d ? d.fillColor : void 0, f.color, this.zone ? this.zone.color : void 0, this.color), this.upperGraphic.attr({
          fill: d
        }), t(this, c))));
        this.connector[a](b.getConnectorAttribs(this));
      }
    });
    "";
  });
  n(c, "masters/modules/dumbbell.src.js", [], function () {});
});